import React, { useEffect } from 'react';
import sliderData from '../../json/instagramimage.json';
import '../newproduct/style/style.css';
import 'aos/dist/aos.css';
import './style/adpage.css';
import AOS from 'aos';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay, Pagination } from 'swiper/modules';

const InstgramAdPage = () => {
  useEffect(() => {
    AOS.init({ duration: 800, easing: 'ease-in-out', once: true });
  }, []);

  return (
    <div>
      <hr />
      <div className='text-center mt-10 InstgramAdPage'>
        <p className='mt-16 tracking-wide text-center text-3xl font-semibold'># StellareBijoux</p>
        <p
          className='text-gray-600 tracking-wide text-sm block w-full md:w-96'
          style={{ margin: '20px auto' }}
        >
          Tag <span className='text-black'>@stellarebijoux</span>{' '}
          <span>in your Instagram posts for a chance to be featured here. Find more inspiration on</span>{' '}
          <span className='text-black'>our Instagram account.</span>
        </p>
      </div>
      <div style={{ width: '80%', margin: ' 56px auto' }}>
        <Swiper
          slidesPerView={1}
          spaceBetween={10}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          breakpoints={{
            640: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            1024: {
              slidesPerView: 5,
              spaceBetween: 10,
            },
            1555: {
              slidesPerView: 6,
              spaceBetween: 10,
            },
            1920: {
              slidesPerView: 6,
              spaceBetween: 20,
            },
            3000: {
              slidesPerView: 6,
              spaceBetween: 20,
            },
          }}
          modules={[Pagination, Autoplay]}
          className='mySwiper'
        >
          {sliderData?.map((x, index) => (
            <SwiperSlide key={index}>
              <div className='img-container'>
                <img src={x.img} alt={`Instagram post ${index}`} className='img-instagram cursor-pointer' />
                <div className='img-overlay'>
                  <svg height='30' viewBox='0 0 64 64' width='30' xmlns='http://www.w3.org/2000/svg' className='icon-svg'>
                  <g fill-rule='evenodd'>
                      <path
                        d='m48 64h-32a16.0007 16.0007 0 0 1 -16-16v-32a16.0007 16.0007 0 0 1 16-16h32a16 16 0 0 1 16 16v32a16 16 0 0 1 -16 16'
                        fill='#FF3A55'
                      ></path>
                      <path
                        d='m30 18h18a9.0006 9.0006 0 0 0 .92-17.954c-.306-.017-.609-.046-.92-.046h-32a16.0007 16.0007 0 0 0 -16 16v32a30.0007 30.0007 0 0 1 30-30'
                        fill='#FF796C'
                      ></path>
                      <path
                        d='m48 32a16 16 0 1 0 16 16v-32a16 16 0 0 1 -16 16'
                        fill='#E00047'
                      ></path>
                    </g>
                    <circle cx='44.5' cy='19.5' fill='#fff' r='2.5'></circle>
                    <path
                      d='m32 24a8 8 0 1 1 -8 8 8.0042 8.0042 0 0 1 8-8zm0-4a12 12 0 1 1 -12 12 12.0057 12.0057 0 0 1 12-12z'
                      fill='#fff'
                      fill-rule='evenodd'
                    ></path>
                    <path
                      d='m52 22a10 10 0 0 0 -10-10h-20a10 10 0 0 0 -10 10v20a10 10 0 0 0 10 10h20a10 10 0 0 0 10-10zm4 0a14 14 0 0 0 -14-14h-20a14 14 0 0 0 -14 14v20a14 14 0 0 0 14 14h20a14 14 0 0 0 14-14z'
                      fill='#fff'
                      fill-rule='evenodd'
                    ></path>
                  </svg>
                  <p
                    className='title-instagram-page '
                    data-aos='fade-up'
                    data-aos-anchor-placement='center-bottom'
                    style={{ position: 'absolute', top: '45%', left: '20%' }}
                  >
                    #stellare bijoux
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default InstgramAdPage;
